import { render, staticRenderFns } from "./quitCoHost.vue?vue&type=template&id=2ae197f2&scoped=true"
import script from "./quitCoHost.vue?vue&type=script&lang=js"
export * from "./quitCoHost.vue?vue&type=script&lang=js"
import style0 from "./quitCoHost.vue?vue&type=style&index=0&id=2ae197f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae197f2",
  null
  
)

export default component.exports